import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.string.trim";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var path = process.env.VUE_APP_BASE_API;
import { createStationBaseInfo, deleteStationBaseInfo as _deleteStationBaseInfo, deleteStationBaseInfoByIds, updateStationBaseInfo, findStationBaseInfo, getStationBaseInfoList } from '@/api/bairun/stationBaseInfo'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { getDict } from '@/utils/dictionary'; // 获取字典数据的func

import { regionData, CodeToText } from 'element-china-area-data'; // 省市区联动

import { mapGetters } from 'vuex';
import CustomPic from '@/components/customPic';

var _this;

export default {
  name: 'StationBaseInfo',
  components: {
    CustomPic: CustomPic
  },
  mixins: [infoList],
  data: function data() {
    return {
      fullscreenLoading: false,
      hideUploadComponent: false,
      uploadLimitNum: 1,
      uploadFileList: [],
      path: path,
      listApi: getStationBaseInfoList,
      stationStatusDict: [],
      dialogFormVisible: false,
      dialogStatusFormVisible: false,
      regionDataOptions_: regionData,
      deleteVisible: false,
      multipleSelection: [],
      bairunLogo: require('@/assets/bairun-logo.jpg'),
      qrcodeText: '',
      qrcodeDialogVisible: false,
      qrcodeDialogTitle: '',
      defaultStatSort: {
        '10001': 8,
        '10002': 10,
        '10003': 3,
        '10004': 12,
        '10005': 11,
        '10006': 2,
        '10008': 15,
        '10009': 14,
        '10010': 6,
        '10011': 4,
        '10012': 9,
        '10013': 5,
        '10014': 7,
        '10015': 13
      },
      formData: {
        stationName: null,
        stationType: 1,
        stationBoss: null,
        stationBossPhone: null,
        stationRegion: ['440000', '441200', '441202'],
        provinceId: 440000,
        cityId: 441200,
        districtId: 441202,
        stationAddress: null,
        stationLandmark: null,
        stationUrl: null,
        longitude: null,
        latitude: null,
        stationIntroduce: null,
        stationPhone: null,
        stationStatus: 2,
        systemUserName: null,
        isStatSort: 1,
        statSort: 0
      },
      rules: {
        stationName: [{
          required: true,
          message: '请输入油站名称',
          trigger: 'blur'
        }],
        stationBoss: [{
          required: true,
          message: '请输入油站负责人',
          trigger: 'blur'
        }],
        stationBossPhone: [{
          required: true,
          message: '请输入油站负责人电话',
          trigger: 'blur'
        }],
        stationRegion: [{
          required: true,
          message: '请选择油站所在区域',
          trigger: 'blur'
        }],
        stationAddress: [{
          required: true,
          message: '请输入油站详细地址',
          trigger: 'blur'
        }],
        stationLandmark: [{
          required: true,
          message: '请输入油站地标',
          trigger: 'blur'
        }],
        stationUrl: [{
          required: true,
          message: '请输入油站图标',
          trigger: 'blur'
        }],
        longitude: [{
          required: true,
          message: '请输入高德坐标',
          trigger: 'blur'
        }],
        latitude: [{
          required: true,
          message: '请输入高德坐标',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  // eslint-disable-next-line vue/order-in-components
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatStationStatusTag: function formatStationStatusTag(bool) {
      if (bool != null) {
        return bool === 1 ? 'success' : bool === 2 ? 'danger' : bool === 3 ? 'warning' : 'info';
      } else {
        return 'info';
      }
    },
    formatStationStatusText: function formatStationStatusText(bool) {
      if (bool != null) {
        return bool === 1 ? '营业中' : bool === 2 ? '已停业' : bool === 3 ? '维护中' : '未知';
      } else {
        return '';
      }
    }
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('StationBaseInfo init');
                _context2.next = 3;
                return _this3.getTableData();

              case 3:
                _context2.next = 5;
                return _this3.setStartMap();

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    toTarget: function toTarget(name, id) {
      if (id === null) {
        this.$router.push(name);
      } else {
        this.$router.push({
          name: name,
          params: {
            stationId: id
          }
        });
      }
    },
    handleRegionChange: function handleRegionChange(optionValue) {
      this.formData.provinceId = parseInt(optionValue[0]);
      this.formData.cityId = parseInt(optionValue[1]);
      this.formData.districtId = parseInt(optionValue[2]);
      this.formData.provinceName = CodeToText[optionValue[0]];
      this.formData.cityName = CodeToText[optionValue[1]];
      this.formData.districtName = CodeToText[optionValue[2]];
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    onReset: function onReset() {
      this.searchInfo = {};
      this.onSubmit();
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    updateStationBaseInfo: function updateStationBaseInfo(row) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return findStationBaseInfo({
                  ID: row.ID
                });

              case 2:
                res = _context3.sent;
                _this4.type = 'update';

                if (res.code === 0) {
                  _this4.formData = res.data.resStationBaseInfo;
                  _this4.formData.isStatSort = res.data.resStationBaseInfo.statSort > 0 ? 1 : 2;
                  _this4.formData.stationRegion = [String(_this4.formData.provinceId), String(_this4.formData.cityId), String(_this4.formData.districtId)];

                  if (res.data.resStationBaseInfo.stationUrl !== '') {
                    _this4.uploadFileList = [{
                      name: res.data.resStationBaseInfo.stationName,
                      url: res.data.resStationBaseInfo.stationUrl
                    }];
                    _this4.hideUploadComponent = true;
                  } else {
                    _this4.uploadFileList = [];
                    _this4.hideUploadComponent = false;
                  }

                  _this4.dialogFormVisible = true;
                }

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    handleMoreCommand: function handleMoreCommand(command) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var funcName, funcParams;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(!command || Object.prototype.hasOwnProperty.call(command, 'triggle') !== true)) {
                  _context4.next = 3;
                  break;
                }

                _this5.$message({
                  type: 'info',
                  message: '未设置指令'
                });

                return _context4.abrupt("return");

              case 3:
                funcName = command.triggle;
                funcParams = Object.prototype.hasOwnProperty.call(command, 'params') ? command.params : '';
                _context4.t0 = funcName;
                _context4.next = _context4.t0 === 'updateStationBaseInfoStatus' ? 8 : _context4.t0 === 'toTarget' ? 11 : 13;
                break;

              case 8:
                _context4.next = 10;
                return _this5.updateStationBaseInfoStatus(funcParams);

              case 10:
                return _context4.abrupt("break", 15);

              case 11:
                _this5.toTarget(funcParams.name, funcParams.stationId);

                return _context4.abrupt("break", 15);

              case 13:
                _this5.$message({
                  type: 'warning',
                  message: '无效的操作指令'
                });

                return _context4.abrupt("break", 15);

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    updateStationBaseInfoStatus: function updateStationBaseInfoStatus(row) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return findStationBaseInfo({
                  ID: row.ID
                });

              case 2:
                res = _context5.sent;
                _this6.type = 'status';

                if (res.code === 0) {
                  _this6.formData = res.data.resStationBaseInfo;
                  _this6.formData.stationRegion = [String(_this6.formData.provinceId), String(_this6.formData.cityId), String(_this6.formData.districtId)];
                  _this6.dialogStatusFormVisible = true;
                }

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      this.qrcodeDialogVisible = false;
      this.qrcodeText = '';
      this.qrcodeDialogTitle = '';
      this.formData = {
        stationName: null,
        stationType: 1,
        stationBoss: null,
        stationBossPhone: null,
        stationRegion: ['440000', '441200', '441202'],
        provinceId: 440000,
        cityId: 441200,
        districtId: 441202,
        stationAddress: null,
        stationLandmark: null,
        longitude: null,
        latitude: null,
        stationIntroduce: null,
        stationPhone: null,
        stationStatus: 2,
        sysUserName: null,
        isStatSort: 1,
        statSort: 0
      };
    },
    closeStatusDialog: function closeStatusDialog() {
      this.dialogStatusFormVisible = false;
    },
    deleteStationBaseInfo: function deleteStationBaseInfo(row) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                row.visible = false;
                _context6.next = 3;
                return _deleteStationBaseInfo({
                  ID: row.ID
                });

              case 3:
                res = _context6.sent;

                if (!(res.code === 0)) {
                  _context6.next = 9;
                  break;
                }

                _this7.$message({
                  type: 'success',
                  message: '删除成功'
                });

                if (_this7.tableData.length === 1 && _this7.page > 1) {
                  _this7.page--;
                }

                _context6.next = 9;
                return _this7.getTableData();

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onBatchDeleteStationBaseInfo: function onBatchDeleteStationBaseInfo() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var ids, res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                ids = [];
                _this8.multipleSelection && _this8.multipleSelection.map(function (item) {
                  ids.push(item.ID);
                });
                _context7.next = 4;
                return deleteStationBaseInfoByIds({
                  ids: ids
                });

              case 4:
                res = _context7.sent;

                if (!(res.code === 0)) {
                  _context7.next = 11;
                  break;
                }

                _this8.$message({
                  type: 'success',
                  message: '删除成功'
                });

                if (_this8.tableData.length === ids.length) {
                  _this8.page--;
                }

                _this8.deleteVisible = false;
                _context7.next = 11;
                return _this8.getTableData();

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    enterDialog: function enterDialog() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _this9.$refs['elForm'].validate( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(valid) {
                    var res;
                    return regeneratorRuntime.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            if (valid) {
                              _context8.next = 2;
                              break;
                            }

                            return _context8.abrupt("return");

                          case 2:
                            _context8.t0 = _this9.type;
                            _context8.next = _context8.t0 === 'create' ? 5 : _context8.t0 === 'update' ? 9 : _context8.t0 === 'status' ? 14 : 18;
                            break;

                          case 5:
                            _context8.next = 7;
                            return createStationBaseInfo(_this9.formData);

                          case 7:
                            res = _context8.sent;
                            return _context8.abrupt("break", 20);

                          case 9:
                            _this9.formData.statSort = _this9.formData.isStatSort === 1 ? _this9.defaultStatSort[_this9.formData.ID + ''] : 0;
                            _context8.next = 12;
                            return updateStationBaseInfo(_this9.formData);

                          case 12:
                            res = _context8.sent;
                            return _context8.abrupt("break", 20);

                          case 14:
                            _context8.next = 16;
                            return updateStationBaseInfo(_this9.formData);

                          case 16:
                            res = _context8.sent;
                            return _context8.abrupt("break", 20);

                          case 18:
                            _this9.$message({
                              type: 'info',
                              message: '无效操作'
                            });

                            return _context8.abrupt("return");

                          case 20:
                            if (!(res.code === 0)) {
                              _context8.next = 26;
                              break;
                            }

                            _this9.$message({
                              type: 'success',
                              message: '操作成功'
                            });

                            _this9.closeDialog();

                            _this9.closeStatusDialog();

                            _context8.next = 26;
                            return _this9.getTableData();

                          case 26:
                          case "end":
                            return _context8.stop();
                        }
                      }
                    }, _callee8);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    // 唤起弹窗 新增油站基础信息
    openAddStationBaseInfoDialog: function openAddStationBaseInfoDialog() {
      this.type = 'create';
      this.uploadFileList = [];
      this.hideUploadComponent = false;
      this.dialogFormVisible = true;
    },
    setStartMap: function setStartMap() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return getDict('stationStatus');

              case 2:
                _this10.stationStatusDict = _context10.sent;

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    },
    handleUploadChange: function handleUploadChange(file, uploadFileList) {
      this.hideUploadComponent = uploadFileList.length >= this.uploadLimitNum;
    },
    checkFile: function checkFile(file) {
      this.fullscreenLoading = true;
      var isJPG = file.type === 'image/jpeg';
      var isPng = file.type === 'image/png';
      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPng) {
        this.$message.error('上传头像图片只能是 JPG或png 格式!');
        this.fullscreenLoading = false;
      }

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        this.fullscreenLoading = false;
      }

      return (isPng || isJPG) && isLt2M;
    },
    submitUpload: function submitUpload() {
      this.$refs.stationPictureUpload.submit();
    },
    uploadSuccess: function uploadSuccess(res) {
      this.fullscreenLoading = false;

      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '上传成功'
        });

        if (res.data.file.url && res.data.file.url.slice(0, 4) !== 'http') {
          this.formData.stationUrl = window.location.protocol + '//' + window.location.host.trim('/') + path + res.data.file.url;
        } else {
          this.formData.stationUrl = res.data.file.url;
        }
      } else {
        this.$message({
          type: 'warning',
          message: res.msg
        });
      }
    },
    uploadError: function uploadError() {
      this.$message({
        type: 'error',
        message: '上传失败'
      });
      this.fullscreenLoading = false;
    },
    handleUploadRemove: function handleUploadRemove(file, uploadFileList) {
      if (uploadFileList.length === 0) {
        this.uploadFileList = [];
      } else {
        var dl = this.uploadFileList.indexOf(file);
        this.uploadFileList.splice(dl, 1);
      }

      this.hideUploadComponent = uploadFileList.length >= this.uploadLimitNum;
      this.$message({
        type: 'warning',
        message: '已移除'
      });
      this.fullscreenLoading = false;
    },
    handleOverUploadLimit: function handleOverUploadLimit() {
      this.$message({
        type: 'warning',
        message: '最多上传一张油站图标'
      });
      this.fullscreenLoading = false;
    },
    onViewQrcode: function onViewQrcode(qrcodeText, title) {
      debugger;
      this.qrcodeText = qrcodeText;
      this.qrcodeDialogVisible = true;
      this.qrcodeDialogTitle = title;
    }
  }
};